// extracted by mini-css-extract-plugin
export default {"productPage":"Product_productPage__VWuIF","products":"Product_products__dWkrv","heading":"Product_heading__IffLI"};